import { Serializable } from './commom/serializable';
import { Usuario } from './usuario';
import { Empresa } from './empresa';

export class RecebeLote implements Serializable<RecebeLote> {
    public Id: number;
    public NumLote: number;
    public Usuario: Usuario;
    public Empresa: Empresa;
    public DataCadastro: Date;
    public DataLiberacao: Date;
    public DataRevisao: Date;
    public QtdeIrrecuperavel: number;
    public QtdeInspecao: number;
    public UsuarioInspecao: number;
    public DataInspecao: Date;
    public Obs: string;
    public ImgInspecao: string; 

    deserialize(input: Object): RecebeLote {
        Object.assign(this, input);

        return this;
    }

}


// WEBPACK FOOTER //
// ./src/entities/recebe-lote.ts